import React from "react";

// Detect desktop vs mobile to default the nav visibility on non-mobile screens
export function useMediaQuery(query: string) {
    const [matches, setMatches] = React.useState<boolean>(() => typeof window !== 'undefined' ? window.matchMedia(query).matches : true);
    React.useEffect(() => {
        const mq = window.matchMedia(query);
        const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
        if (mq.addEventListener) mq.addEventListener('change', handler);
        else mq.addListener(handler);
        setMatches(mq.matches);
        return () => {
            if (mq.removeEventListener) mq.removeEventListener('change', handler);
            else mq.removeListener(handler);
        };
    }, [query]);
    return matches;
}
